import React, { useEffect, useState } from "react"
import {
  Table,
  Button,
  Modal,
  Popconfirm,
  Input,
  notification,
  Divider,
  InputNumber,
  Select,
} from "antd"
import { endpoint } from "../../config/api"
import { MainActions, AuthActions } from "redux-store/models"
import { connect } from "react-redux"

const ProductsPage = ({
  accountInfo,
  getAllServices,
  activeSkinId,
  allServices,
}) => {
  const [data, setData] = useState([])
  const [companies, setCompanies] = useState([])
  const [attributes, setAttributes] = useState([])
  const [loading, setLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [editingItem, setEditingItem] = useState(null)

  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [skinId, setSkinId] = useState(1)

  const token = accountInfo?.token

  const [variants, setVariants] = useState([
    {
      price: 0,
      stock: 0,
      attributes_json: {},
      imageFile: null,
      image_path: "",
      preview: "",
    },
  ])

  const fetchData = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${endpoint}system-products?skin_id=${skinId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const json = await res.json()
      setData(json)
    } catch {
      notification.error({
        message: "Errore",
        description: "Impossibile caricare i prodotti.",
      })
    } finally {
      setLoading(false)
    }
  }

  const fetchCompanies = async () => {
    await getAllServices(
      activeSkinId === -1 ? 2 : activeSkinId,
      "System Products",
      1,
      1,
      25,
    )
  }

  const fetchAttributes = async () => {
    try {
      const res = await fetch(`${endpoint}attributes`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      const json = await res.json()
      setAttributes(json)
    } catch {
      notification.error({ message: "Errore attributi" })
    }
  }

  useEffect(() => {
    fetchData()
    fetchAttributes()
    fetchCompanies()
  }, [skinId])

  const openModal = (item = null) => {
    if (item) {
      setEditingItem(item)
      setName(item.name)
      setDescription(item.description)
      setSkinId(item.skin_id)

      const normalized = item.variants?.length
        ? item.variants.map((v) => ({
            id: v.id,
            price: v.price,
            stock: v.stock,
            attributes_json:
              v.attributes_json && typeof v.attributes_json === "object"
                ? v.attributes_json
                : {},

            imageFile: null,
            image_path: v.image_path,
            preview: v.image_path || "",
          }))
        : [
            {
              price: 0,
              stock: 0,
              attributes_json: {},
              imageFile: null,
              image_path: "",
              preview: "",
            },
          ]

      setVariants(normalized)
    } else {
      setEditingItem(null)
      setName("")
      setDescription("")
      setVariants([
        {
          price: 0,
          stock: 0,
          attributes_json: {},
          imageFile: null,
          image_path: "",
          preview: "",
        },
      ])
    }

    setVisible(true)
  }

  const updateVariant = (index, key, value) => {
    const copy = [...variants]
    copy[index][key] = value
    setVariants(copy)
  }

  const updateAttributeValue = (variantIndex, attributeName, value) => {
    const copy = [...variants]

    if (!copy[variantIndex].attributes_json) {
      copy[variantIndex].attributes_json = {}
    }

    copy[variantIndex].attributes_json[attributeName] = value

    setVariants(copy)
  }

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = reject
    })
  }

  const handleFileChange = async (index, file) => {
    if (!file) return

    const base64 = await getBase64(file)

    const copy = [...variants]
    copy[index].imageFile = file
    copy[index].preview = base64

    setVariants(copy)
  }

  const addVariant = () => {
    setVariants([
      ...variants,
      {
        price: 0,
        stock: 0,
        attributes_json: {},
        imageFile: null,
        image_path: "",
        preview: "",
      },
    ])
  }

  const removeVariant = (index) => {
    const copy = variants.filter((_, i) => i !== index)

    setVariants(
      copy.length
        ? copy
        : [
            {
              price: 0,
              stock: 0,
              attributes_json: {},
              imageFile: null,
              image_path: "",
              preview: "",
            },
          ],
    )
  }

 const updateProduct = async (productId, payload) => {
  const formData = new FormData()

  Object.entries(payload).forEach(([key, value]) => {
    if (key !== "variants") {
      formData.append(key, value)
    }
  })

  if (payload.variants) {
    payload.variants.forEach((v, index) => {
      const prefix = `variants[${index}]`

      if (v.id) {
        formData.append(`${prefix}[id]`, v.id)
      }

      formData.append(`${prefix}[price]`, v.price ?? 0)
      formData.append(`${prefix}[stock]`, v.stock ?? 0)

      if (v.imageFile instanceof File) {
        formData.append(`${prefix}[image]`, v.imageFile)
      }

      if (v.attributes_json && attributes.length) {
        let optIndex = 0

        Object.entries(v.attributes_json).forEach(([attrName, value]) => {
          const attr = attributes.find((a) => a.name === attrName)
          const match = attr?.values?.find(
            (val) => val.value === value
          )

          if (attr && match) {
            formData.append(
              `${prefix}[selected_options][${optIndex}][attribute_id]`,
              attr.id
            )

            formData.append(
              `${prefix}[selected_options][${optIndex}][value_id]`,
              match.id
            )

            optIndex++
          }
        })
      }
    })
  }

  // EXACTLY same behavior as before
  const isEditing = !!productId

  if (isEditing) {
    formData.append("_method", "PUT")
  }

  const url = isEditing
    ? `${endpoint}system-products/${productId}`
    : `${endpoint}system-products`

  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  })

  return await res.json()
}

  const handleSave = async () => {
    if (!name.trim()) {
      return notification.warning({ message: "Nome obbligatorio" })
    }

    setConfirmLoading(true)

    try {
      await updateProduct(
        editingItem?.id,
        {
          name,
          description,
          skin_id: skinId,
          company_id: editingItem ? editingItem.company_id : "",
          variants,
        },
      )

      notification.success({
        message: editingItem ? "Prodotto aggiornato!" : "Prodotto creato!",
      })

      setVisible(false)
      fetchData()
    } catch (err) {
      notification.error({
        message: "Errore durante il salvataggio",
      })
    } finally {
      setConfirmLoading(false)
    }
  }

  const handleDelete = async (id) => {
    setLoading(true)
    try {
      const res = await fetch(`${endpoint}system-products/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!res.ok) throw new Error()

      notification.success({
        message: "Eliminato con successo",
      })

      fetchData()
    } catch {
      notification.error({
        message: "Errore eliminazione",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleCompanyChange = async (productId, companyId) => {
    const product = data.find((p) => p.id === productId)

    try {
      await updateProduct(
        productId,
        {
          name: product.name,
          description: product.description,
          skin_id: product.skin_id,
          company_id: companyId,
          variants: product.variants,
        },
      )

      notification.success({
        message: "Company updated",
      })

      setData((prev) =>
        prev.map((p) => (p.id === productId ? { ...p, company_id: companyId } : p)),
      )
    } catch (err) {
      notification.error({
        message: "Failed to update company",
      })
    }
  }

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
    },
    {
      title: "Descrizione",
      dataIndex: "description",
      render: (val) => val || "-",
    },

    {
      title: "Prezzo",
      render: (record) => {
        const first = record.variants?.[0]
        return first ? `${first.price} €` : "-"
      },
    },

    {
      title: "Stock Totale",
      render: (record) => {
        if (!record.variants) return 0
        return record.variants.reduce((sum, v) => sum + Number(v.stock || 0), 0)
      },
    },

    {
      title: "Varianti",
      render: (record) => record.variants?.length || 0,
    },
    {
      title: "Company",
      render: (record) => (
        <Select
          value={record.company_id}
          style={{ width: 180 }}
          onChange={(value) => handleCompanyChange(record.id, value)}
        >
          {allServices?.map((service) => (
            <Select.Option key={service.number_id} value={service.number_id}>
              {service.full_name || service.name}
            </Select.Option>
          ))}
        </Select>
      ),
    },

    {
      title: "Azioni",
      render: (record) => (
        <>
          <a onClick={() => openModal(record)}>Modifica</a>
          <Divider type="vertical" />
          <Popconfirm
            title="Eliminare prodotto?"
            onConfirm={() => handleDelete(record.id)}
          >
            <a style={{ color: "red" }}>Elimina</a>
          </Popconfirm>
        </>
      ),
    },
  ]

  return (
    <div className="attributes-container">
      <div className="header-section">
        <h1 style={{ margin: 0 }}>Prodotti</h1>
        <Button type="primary" onClick={() => openModal()}>
          Nuovo Prodotto
        </Button>
      </div>

      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        rowKey="id"
        className="modern-table"
        pagination={false}
        scroll={{ y: "calc(100vh - 240px)" }}
      />

      <Modal
        title={editingItem ? "Modifica Prodotto" : "Nuovo Prodotto"}
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={handleSave}
        confirmLoading={confirmLoading}
        width={1000}
        bodyStyle={{ padding: 24 }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div>
            <div style={{ fontSize: 12, marginBottom: 4, color: "#666" }}>
              Nome prodotto
            </div>
            <Input
              placeholder="Es. Gaming Keyboard"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={{ height: 40 }}
            />
          </div>
          <div>
            <div style={{ fontSize: 12, marginBottom: 4, color: "#666" }}>
              Descrizione
            </div>
            <Input.TextArea
              style={{ fontWeight: "normal" }}
              placeholder="Descrizione prodotto..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
            />
          </div>
        </div>

        <Divider />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <h3 style={{ margin: 0 }}>Varianti</h3>
          <Button type="dashed" onClick={addVariant}>
            + Aggiungi Variante
          </Button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {variants.map((v, i) => (
            <div
              key={i}
              style={{
                border: "1px solid #eee",
                padding: 15,
                marginBottom: 15,
                borderRadius: 8,
                background: "#fafafa",
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <b>Variante #{i + 1}</b>

                <Button
                  size="small"
                  style={{ color: "#ff4d4f" }}
                  onClick={() => removeVariant(i)}
                >
                  Rimuovi
                </Button>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 12,
                  marginBottom: 16,
                }}
              >
                <div>
                  <div style={{ fontSize: 12, marginBottom: 4, color: "#666" }}>
                    Prezzo
                  </div>
                  <InputNumber
                    style={{ width: "100%" }}
                    value={v.price}
                    min={0}
                    onChange={(val) => updateVariant(i, "price", val)}
                  />
                </div>
                <div>
                  <div style={{ fontSize: 12, marginBottom: 4, color: "#666" }}>
                    Stock
                  </div>
                  <InputNumber
                    style={{ width: "100%" }}
                    value={v.stock}
                    min={0}
                    onChange={(val) => updateVariant(i, "stock", val)}
                  />
                </div>
              </div>

              <Divider />

              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, marginBottom: 4, color: "#666" }}>
                  Immagine Variante
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleFileChange(i, e.target.files[0])}
                  style={{ fontSize: "12px" }}
                />
                {v.preview && (
                  <div style={{ marginTop: 8 }}>
                    <img
                      src={v.preview}
                      alt="preview"
                      style={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        borderRadius: 4,
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}
              </div>

              {attributes?.map((attr) => {
                const selected = v.attributes_json?.[attr.name]

                return (
                  <div key={attr.id} style={{ marginBottom: 10 }}>
                    <div style={{ fontSize: 12 }}>{attr.name}</div>

                    <Select
                      style={{ width: "100%" }}
                      value={selected}
                      onChange={(value) => updateAttributeValue(i, attr.name, value)}
                    >
                      {attr.values.map((val) => (
                        <Select.Option key={val.id} value={val.value}>
                          {val.value}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    accountInfo: state.auth.accountInfo,
    activeSkinId: state.main.activeSkinId,
    allServices: state.auth.allServices.data,
  }
}

export default connect(mapStateToProps, { ...MainActions, ...AuthActions })(
  ProductsPage,
)
